import React from 'react';
import Item from './components/Item';
import style from './index.module.scss';

export default () => {
  function handlerClick() {
    //@ts-ignore
    window.open(window.globalData.onlineService);
  }
  return (
    <div className={style.container}>
      <div className={style.content}>
        <Item
          text="在线客服"
          icon={require('./assets/service.png')}
          activeIcon={require('./assets/service_white.png')}
          onClick={handlerClick}
        />
        <Item text="电话质询" icon={require('./assets/phone.png')} activeIcon={require('./assets/phone_white.png')}>
          <div className={style.phone}>
            <img src={require('./assets/modal_phone.png')} alt="" className={style.modalPhone} />
            <div className={style.phoneText}>客服热线</div>
            <div className={style.phoneTel}>133-0518-5550</div>
          </div>
        </Item>
        <Item text="扫码关注" icon={require('./assets/qrcode.png')} activeIcon={require('./assets/13305185550_qrcode.png')}>
          <div className={style.qrcode}>
            <img src={require('./assets/13305185550_qrcode.png')} alt="" className={style.qrImg} />
            <div className={style.qrcodeText}>微信识别二维码添加好友 获取更多产品信息</div>
          </div>
        </Item>
      </div>
    </div>
  );
};
